// ErrorLoadingContext.js
import React, { createContext, useState } from 'react';

const ErrorLoadingContext = createContext();

const ErrorLoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  return (
    <ErrorLoadingContext.Provider value={{
      loading,
      setLoading,
      error,
      setError
    }}>
      {children}
    </ErrorLoadingContext.Provider>
  );
};

export { ErrorLoadingContext, ErrorLoadingProvider };



// export const newCreateGround = async (req, res) => {
//   try {
//     const {
//       loc,
//       numberOfFields,
//       fields,
//       isFullGround,
//       fullGround,
//       advancePayment,
//       liveBookingEnable,
//       multipleTimes,
//       timing,
//     } = req.body;

//     // Validate loc field
//     if (
//       !loc ||
//       loc.type !== "Point" ||
//       !Array.isArray(loc.coordinates) ||
//       loc.coordinates.length !== 2
//     ) {
//       return res
//         .status(200)
//         .json({
//           status: false,
//           message:
//             "Invalid loc field. It should be a GeoJSON Point with [longitude, latitude].",
//         });
//     }
//     const isValidTimeFormat = (time) =>
//       /^([0-1]\d|2[0-3]):([0-5]\d)$/.test(time);

//     // Validate advance payment
//     if (advancePayment < 1 || advancePayment > 100) {
//       return res
//         .status(200)
//         .json({
//           status: false,
//           message: "Advance payment should have a range from 1-100.",
//         });
//     }

//     let fieldsWithIds = [];

//     // Handle the full ground scenario
//     if (numberOfFields === 0 && isFullGround) {
//       fieldsWithIds.push({
//         name: "Full Ground",
//         ...fullGround,
//       });
//     } else {
//       if (numberOfFields !== fields.length) {
//         return res
//           .status(200)
//           .json({
//             status: false,
//             message:
//               "Number of fields does not match the provided fields data.",
//           });
//       }

//       // Process each field
//       fieldsWithIds = await Promise.all(
//         fields.map(async (field, index) => {
//           const fieldName = field.name || `Main Field ${index + 1}`;

//           if (field.allowedSports && Array.isArray(field.allowedSports)) {
//             const validatedSports = [];
//             for (const sportId of field.allowedSports) {
//               if (!mongoose.Types.ObjectId.isValid(sportId)) {
//                 return res
//                   .status(200)
//                   .json({
//                     status: false,
//                     message: `Invalid sport ID: ${sportId}`,
//                   });
//               }
//               const sportExists = await Sports.exists({ _id: sportId });
//               if (!sportExists) {
//                 return res
//                   .status(200)
//                   .json({
//                     status: false,
//                     message: `Sport ID does not exist: ${sportId}`,
//                   });
//               }
//               validatedSports.push(sportId);
//             }
//             field.allowedSports = validatedSports;
//           }

//           let subFieldsWithIds = [];
//           if (field.subFields && Array.isArray(field.subFields)) {
//             subFieldsWithIds = field.subFields.map((subField, subIndex) => ({
//               ...subField,
//               name: subField.name || `Subfield ${subIndex + 1}`,
//             }));
//           }

//           return {
//             ...field,
//             name: fieldName,
//             noOfSubfields: subFieldsWithIds.length,
//             subFields: subFieldsWithIds,
//           };
//         })
//       );
//     }

//     // Handle timing entries based on multipleTimes flag
//     let timingArray = [];
//     if (multipleTimes) {
//       // Allow multiple timing entries
//       if (!Array.isArray(timing) || timing.length < 2) {
//         return res
//           .status(200)
//           .json({
//             status: false,
//             message:
//               "At least 2 timing objects are required when multipleTimes is true.",
//           });
//       }
//       timing.forEach((t, index) => {
//         if (!isValidTimeFormat(t.startTime) || !isValidTimeFormat(t.endTime)) {
//           return res
//             .status(200)
//             .json({
//               status: false,
//               message: `Invalid time format in timing array for startTime or endTime. Expected "HH:MM".`,
//             });
//         }
//         if (t.peakTime && !isValidTimeFormat(t.peakTime)) {
//           return res
//             .status(200)
//             .json({
//               status: false,
//               message:
//                 'Invalid time format for peakTime in timing array. Expected "HH:MM".',
//             });
//         }
//         timingArray.push({
//           name: `Timing ${index + 1}`, // Automatically assigning name
//           startTime: t.startTime,
//           endTime: t.endTime,
//           peakTime: t.peakTime,
//           StartDays: t.StartDays || [],
//         });
//       });
//     } else {
//       // Only one timing entry allowed
//       if (!Array.isArray(timing) || timing.length !== 1) {
//         return res
//           .status(200)
//           .json({
//             status: false,
//             message:
//               "Only one timing object is allowed when multipleTimes is false.",
//           });
//       }
//       const t = timing[0];
//       if (!isValidTimeFormat(t.startTime) || !isValidTimeFormat(t.endTime)) {
//         return res
//           .status(200)
//           .json({
//             status: false,
//             message:
//               'Invalid time format for startTime or endTime. Expected "HH:MM".',
//           });
//       }
//       if (t.peakTime && !isValidTimeFormat(t.peakTime)) {
//         return res
//           .status(200)
//           .json({
//             status: false,
//             message: 'Invalid time format for peakTime. Expected "HH:MM".',
//           });
//       }
//       timingArray.push({
//         name: "Timing 1", // Automatically assigning name
//         startTime: t.startTime,
//         endTime: t.endTime,
//         peakTime: t.peakTime,
//         StartDays: t.StartDays || [],
//       });
//     }

//     const groundData = {
//       ...req.body,
//       createdBy: req.user_id,
//       owner: req.user_id,
//       noOfFields: fieldsWithIds.length,
//       fields: fieldsWithIds,
//       liveBookingEnable,
//       timing: timingArray, // Save the timing array
//     };

//     const ground = new Grounds(groundData);
//     const savedGround = await ground.save();

//     res
//       .status(201)
//       .json({
//         status: true,
//         message: "Ground created successfully",
//         ground: savedGround,
//       });
//   } catch (error) {
//     console.error("Error creating ground:", error.message);
//     res
//       .status(500)
//       .json({
//         status: false,
//         message: "An error occurred while creating the ground.",
//       });
//   }
// };